module.exports = {
	"root": "findify-components-search--query"
};